import { SecondDisciplineStepType } from '@brighterly/lib-core-types/upsell/enums'

import { AppRoute } from '@shared/config'
import { resolveOrderId } from '@shared/lib/routing'

const STEP_ROUTES: Record<SecondDisciplineStepType, AppRoute> = {
  [SecondDisciplineStepType.Upsell]: AppRoute.UpsellPlan,
  [SecondDisciplineStepType.BookDemo]: AppRoute.UpsellBooking,
}

export const resolveSecondDisciplineStepPath = (type: SecondDisciplineStepType, purchasedOrderId: number): string =>
  resolveOrderId(STEP_ROUTES[type], purchasedOrderId)!
